import {
  Exam,
  //Books,
  //Exam,
  Eyeglasses,
  MagicWand,
  Notepad,
  PaintBrushBroad,
  //MagicWand,
  //Notepad,
  //PaintBrushBroad,
  PaperPlaneTilt,
  ProjectorScreenChart,
  //ProjectorScreenChart,
  Sparkle,
  Student,
  Swap,
} from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { LINK } from "../types/app";

// Hook to get translated links
export const useAppLinks = (): LINK[] => {
  const { t } = useTranslation("common");

  return [
    {
      title: t("app.tools.communicationsGenerator.title"),
      description: t("app.tools.communicationsGenerator.description"),
      href: "/communications-generator",
      icon: PaperPlaneTilt,
      id: "1",
    },
    {
      title: t("app.tools.researcher.title"),
      description: t("app.tools.researcher.description"),
      href: "/researcher",
      icon: Eyeglasses,
      id: "2",
    },
    {
      title: t("app.tools.lessonLab.title"),
      description: t("app.tools.lessonLab.description"),
      href: "/lesson-lab",
      icon: Sparkle,
      id: "3",
    },
    {
      title: t("app.tools.magicMarker.title"),
      description: t("app.tools.magicMarker.description"),
      href: "/magic-marker",
      icon: MagicWand,
      disabled: true,
      id: "5",
    },
    {
      title: t("app.tools.resourceCustomiser.title"),
      description: t("app.tools.resourceCustomiser.description"),
      href: "/resource-customiser",
      icon: PaintBrushBroad,
      disabled: true,
      id: "4",
    },
    {
      title: t("app.tools.catchupCoach.title"),
      description: t("app.tools.catchupCoach.description"),
      href: "/catchup-coach",
      icon: Swap,
      disabled: true,
      id: "6",
    },
    {
      title: t("app.tools.examCreator.title"),
      description: t("app.tools.examCreator.description"),
      href: "/exam-creator",
      icon: Exam,
      disabled: true,
      id: "9",
    },
    {
      title: t("app.tools.studentEvaluator.title"),
      description: t("app.tools.studentEvaluator.description"),
      href: "/student-evaluator",
      icon: Student,
      disabled: true,
      id: "7",
    },
    {
      title: t("app.tools.classEvaluator.title"),
      description: t("app.tools.classEvaluator.description"),
      href: "/class-evaluator",
      icon: ProjectorScreenChart,
      disabled: true,
      id: "8",
    },
    {
      title: t("app.tools.classNotes.title"),
      description: t("app.tools.classNotes.description"),
      href: "/class-notes",
      icon: Notepad,
      disabled: true,
      id: "10",
    },
  ] as LINK[];
};

// Hook to get translated generate button texts
export const useGenerateButtonTexts = (): string[] => {
  const { t } = useTranslation("common");

  return [
    t("generate.buttons.generate"),
    t("generate.buttons.go"),
    t("generate.buttons.create"),
    t("generate.buttons.build"),
    t("generate.buttons.launch"),
    t("generate.buttons.start"),
    t("generate.buttons.run"),
    t("generate.buttons.execute"),
    t("generate.buttons.ready"),
    t("generate.buttons.engage"),
    t("generate.buttons.doTheThing"),
    t("generate.buttons.fireItUp"),
    t("generate.buttons.spinTheWheel"),
    t("generate.buttons.makeItSo"),
    t("generate.buttons.letItCook"),
    t("generate.buttons.hitIt"),
    t("generate.buttons.makeItHappen"),
    t("generate.buttons.pullTheLever"),
    t("generate.buttons.punchIt"),
  ];
};

// Legacy exports for backward compatibility
const links = [
  {
    title: "Writing Wizard",
    description:
      "Create tailored parent or student emails, newsletters and announcements in seconds.",
    href: "/writing-wizard",
    icon: PaperPlaneTilt,
    id: "1",
  },
  {
    title: "Researcher",
    description:
      "Get a quick, up-to-date overview on any topic, to broaden your content library or refresh your memory.",
    href: "/researcher",
    icon: Eyeglasses,
    id: "2",
  },
  {
    title: "Lesson Lab",
    description:
      "Fast track your class prep by creating lesson plans, worksheets, and other resources. Transform existing content, or create something new from scratch.",
    href: "/lesson-lab",
    icon: Sparkle,
    id: "3",
  },
  {
    title: "Magic Marker",
    description:
      "Instantly grade assignments and receive insightful feedback on student work.",
    href: "/magic-marker",
    icon: MagicWand,
    disabled: true,
    id: "5",
  },
  {
    title: "Resource Customiser",
    description:
      "Tweak existing documents and teaching resources for a wide range of students, including age range, language, or additional needs.",
    href: "/resource-refinery",
    icon: PaintBrushBroad,
    disabled: true,
    id: "4",
  },
  {
    title: "Catchup Coach",
    description:
      "Create personalised homework, worksheets, or other resources to catch up a student that may have missed lessons or fallen behind",
    href: "/catchup-coach",
    icon: Swap,
    disabled: true,
    id: "6",
  },
  {
    title: "Exam Creator",
    description:
      "Generate customizable quizzes and exams with diverse question types aligned to curriculum standards.",
    href: "/exam-creator",
    icon: Exam,
    disabled: true,
    id: "9",
  },
  {
    title: "Student Evaluator",
    description:
      "Analyse individual student performance and generate detailed progress reports with actionable insights.",
    href: "/student-evaluator",
    icon: Student,
    disabled: true,
    id: "7",
  },
  {
    title: "Class Evaluator",
    description:
      "Analyse class-wide performance trends to identify strengths and areas for improvement.",
    href: "/class-evaluator",
    icon: ProjectorScreenChart,
    disabled: true,
    id: "8",
  },
  {
    title: "Class Notes",
    description:
      "Record your thoughts and let the tool organise them into a sensible folder of student and event notes.",
    href: "/class-notes",
    icon: Notepad,
    disabled: true,
    id: "10",
  },
] as LINK[];

const GENERATE_BUTTON_TEXTS = [
  "Generate",
  "Go",
  "Create",
  "Build",
  "Launch",
  "Start",
  "Run",
  "Execute",
  "Ready?",
  "Engage.",
  "Do the thing",
  "Fire it up",
  "Spin the wheel",
  "Make it so.",
  "Let it cook",
  "Hit it",
  "Make it happen",
  "Pull the lever, Kronk!",
  "Punch it"
]

export { links, GENERATE_BUTTON_TEXTS };
